import popupCss from './haftahave/popup.css';
import popupHtml from './haftahave/popup.html';
import contentCss from './haftahave/content.css';
import contentHtml from './haftahave/content.html';

const { utils } = window.__haftahave;
const {
    addContent,
    addHtmlElement,
    getLocalStorage,
    setCookie,
} = utils;

const isLiveMode = true;
const isHaftahaveView = () => document.location.search === '?hh=1';
const getDataByDomain = (domain) => {
    const map = {
        'https://cheechspizzala.com': [
            'pizza_cheech_s_pizza',
            'Cheech\'s Pizza',
            '15% OFF',
            'HC0000149',
        ],
        'https://vinniespizzeriaca.com': [
            'pizza_vinnie_s_pizzeria',
            'Vinnie\'s Pizzeria',
            '$3 OFF',
            'HC0000157',
        ],
        'https://piccolosnyc.online': [
            'pizza_piccolo_trattoria',
            'Piccolo Trattoria',
            '10% OFF',
            'HC0000148',
        ],
        'https://pizzeriadivine.com': [
            'pizza_pizzeria_divine',
            'Pizzeria Divine',
            'FREE BREAD STICKS',
            'HC0000145',
        ],
        'https://illianospizzeria.com': [
            'pizza_illiano_s_pizza_restaurant',
            'Illiano\'s Pizza Restaurant',
            '10% OFF',
            'HC0000147',
        ],
        'https://nycrust.com': [
            'pizza_ny_crust',
            'NY Crust',
            '10% OFF',
            'HC0000146',
        ],
        'https://samsgiantmanhattanpizzaca.com': [
            'pizza_sam_s_giant_manhattan_pizza',
            'Sam\'s Giant Manhattan Pizza',
            '2 MEDIUM PIZZAS FOR $22.99',
            'HC0000150',
        ],
        'https://aurora.garlicknotpizza.com': [
            'pizza_the_garlic_knot_aurora',
            'The Garlic Knot',
            'FREE KNOTS',
            'HC0000151',
        ],
        'https://fortcollins.garlicknotpizza.com': [
            'pizza_the_garlic_knot_fort_collins',
            'The Garlic Knot',
            'FREE KNOTS',
            'HC0000152',
        ],
        'https://lakewood.garlicknotpizza.com': [
            'pizza_the_garlic_knot_lakewood',
            'The Garlic Knot',
            'FREE KNOTS',
            'HC0000153',
        ],
        'https://thornton.garlicknotpizza.com': [
            'pizza_the_garlic_knot_thornton',
            'The Garlic Knot',
            'FREE KNOTS',
            'HC0000154',
        ],
        'https://westminster.garlicknotpizza.com': [
            'pizza_the_garlic_knot_westminster',
            'The Garlic Knot',
            'FREE KNOTS',
            'HC0000155',
        ],
        'https://parkerrd.garlicknotpizza.com': [
            'pizza_the_garlic_knot_pizza_denver_parker_rd',
            'The Garlic Knot',
            'FREE KNOTS',
            'HC0000156',
        ],
        'https://salslittleitaly.com': [
            'pizza_sal_s_little_italy',
            'Sal\'s Little Italy',
            '10% OFF',
            'HC0000158',
        ],
        'https://italianexpressonline.com': [
            'pizza_italian_express',
            'Italian Express',
            '10% OFF',
            'HC0000159',
        ],
        // 'https://mariopizzaculvercity.com': ['pizza_mario_s_pizza', 'Mario\'s Pizza', 'no-discount', 'no-coupon'],
    };

    if (!map[domain]) {
        return null;
    }

    return map[domain];
};

if (isLiveMode || isHaftahaveView()) {
    const data = getDataByDomain(document.location.origin);
    if (data !== null) {
        // inject popup
        addContent(popupCss, 'css');
        addContent(popupHtml, 'html');
        document.getElementsByClassName('js-modal__close')[0].addEventListener('click', (event) => {
            event.preventDefault();
            document.getElementsByTagName('body')[0].classList.remove('has-modal-open');
            document.getElementsByClassName('o-modal')[0].classList.remove('is-shown');
        });

        // add popup content
        addContent(contentCss, 'css');
        addHtmlElement(contentHtml, document.getElementById('haftahave-modal-content-container'), 'hh-inner');

        // show logo
        const phone = '+112342224283';
        const [merchantCode, storeName, promoText, qrCode] = data;
        const items = document.getElementsByClassName(`${merchantCode} logo`);
        if (items.length > 0) {
            items[0].style.display = 'block';
        }
        const promoItems = document.getElementsByClassName('promo-text');
        if (promoItems.length > 0) {
            promoItems[0].textContent = promoText;
        }
        const text = encodeURIComponent(
            `Hit send to unlock ${promoText || 'promo'} from ${storeName || 'us'} and subscribe to other exclusive`
                + ` offers in the future! (${qrCode})`);

        const smsLinkIos = document.getElementsByClassName('sms-link-ios');
        if (smsLinkIos.length > 0) {
            smsLinkIos[0].href = `sms:${phone}&body=${text}`;
        }
        const smsLinkAndroid = document.getElementsByClassName('sms-link-android');
        if (smsLinkAndroid.length > 0) {
            smsLinkAndroid[0].href = `sms:${phone}?body=${text}`;
        }

        const smsFallbackItems = document.getElementsByClassName('sms-link-fallback');
        Array.from(smsFallbackItems).forEach((item) => {
            item.textContent = `Or just send SMS with text "${qrCode}" to phone number ${phone}`; // eslint-disable-line
        });

        // show popup
        document.getElementsByTagName('body')[0].classList.add('has-modal-open');
        document.getElementsByClassName('o-modal')[0].classList.add('is-shown');

        const { popupLastTimeParamName } = window.__haftahave;
        if (popupLastTimeParamName) {
            const localStorage = getLocalStorage();
            if (localStorage) {
                localStorage.setItem(popupLastTimeParamName, (new Date()).getTime());
            } else {
                setCookie(window.__haftahave.popupLastTimeParamName, (new Date()).getTime(), { expires: 365 });
            }
        }
    }
}
